import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '../store/modules/auth/actions';
import DashboardEstamparia from './empresa/estamparia/dashboard/dashboardEstamparia';
import DashboardEmpresa from './dashboard/dashboardEmpresa';
import DashboardAdmin from './dashboard/dashboardAdmin';

export default function Home() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user) || {};
  const idOperador = useSelector((state) => state.auth.idOperador);

  useEffect(() => {
    const newTitle = '';
    dispatch(actions.titleHeaderChange({ newTitle }));
  }, [dispatch]);

  // Administrador do sistema (Elo): empresas/licenças, mensalidades, tickets e acessos
  if (user.tipoUsuario === 'ADMINISTRADOR') {
    return <DashboardAdmin />;
  }

  // Dashboards (estamparia, OS e geral) só aparecem para:
  // - login da própria empresa (sem operador), ou
  // - operador com tipo de acesso TOTAL e sem grupo de acesso.
  // Demais operadores veem a tela inicial padrão.
  const acessoEmpresa = !idOperador || Number(idOperador) <= 0;
  // Operador com grupo de acesso tem o menu restrito (mesmo com tipo de acesso TOTAL): não vê o dashboard
  const operadorRestrito = !!user.operadorGrupoAcesso;
  const podeVerDashboard = acessoEmpresa || (user.tipoAcesso === 'TOTAL' && !operadorRestrito);
  // Empresas do ramo de estamparia: dashboard com orçamentos, pedidos e produção
  if (user.tipoUsuario === 'EMPRESA' && user.modeloNegocio === 'ESTAMPARIA' && podeVerDashboard) {
    return <DashboardEstamparia />;
  }

  // Demais empresas: dashboard de ordens de serviço (quando há OS de aparelho nos últimos 30 dias)
  // ou dashboard geral (vendas, financeiro e orçamentos). A escolha é feita pelo backend.
  if (user.tipoUsuario === 'EMPRESA' && podeVerDashboard) {
    return <DashboardEmpresa />;
  }

  return (
    <div className="home-dashboard">
      <section className="welcome-card">
        <div>
          <span className="section-eyebrow">Visão geral</span>
          <h1>Olá{user.nome ? `, ${user.nome}` : ''}!</h1>
          <p>Bem-vindo ao seu ambiente de gestão. Use o menu acima para acessar os módulos do sistema.</p>
        </div>
        <div className="welcome-icon"><i className="pi pi-chart-line" /></div>
      </section>
      <section className="home-grid">
        <article className="quick-card"><i className="pi pi-search" /><div><h2>Consultas</h2><p>Encontre cadastros e movimentações com rapidez.</p></div></article>
        <article className="quick-card"><i className="pi pi-file" /><div><h2>Documentos</h2><p>Acompanhe documentos fiscais e operações.</p></div></article>
        <article className="quick-card"><i className="pi pi-chart-bar" /><div><h2>Relatórios</h2><p>Transforme dados em decisões mais seguras.</p></div></article>
      </section>
    </div>
  );
}
